import React from "react";
import { kakaoClipboard, KakaoShareButton } from "react-kakao-share";
import styled from "styled-components";

const KakaoShareButtonT = () => {
  const KAKAO_JAVASCRIPT_KEY = "7ef56a48df1d9f25e037ff0a33df8791";
  const clipData = {
    title: "디지몬상 테스트",
    description: "얼굴 사진을 업로드하여 나와 닮은 디지몬을 찾아보세요.",
    image: "https://snazzy-stardust-69c0a0.netlify.app/logo512.png",
    APIKEY: KAKAO_JAVASCRIPT_KEY,
  };

  return (
    <Button type="button" onClick={() => kakaoClipboard(clipData)}>
      <KakaoShareButton size="30px" />
      카카오 공유&nbsp;
    </Button>
  );
};

export default KakaoShareButtonT;

const Button = styled.button`
  background-color: rgb(254, 229, 0);

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 10px;

  font-size: 20px;
`;
